interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
  subMessage?: string;
}

export function LoadingModal({
  isOpen,
  message = "Processing...",
  subMessage = "This may take a few seconds.",
}: LoadingModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-sm mx-4">
        <div className="flex flex-col items-center space-y-4">
          {/* Loading SVG Animation */}
          <svg
            className="animate-spin h-12 w-12 text-tx-primary"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>

          {/* Message */}
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              {message}
            </h3>
            <p className="text-sm text-gray-600">{subMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
